import { neon } from "@neondatabase/serverless";
import { drizzle } from "drizzle-orm/neon-http";
import * as schema from "./schema";

// Get database URL from environment
const getDatabaseUrl = (): string => {
  const url = import.meta.env.VITE_DATABASE_URL;
  if (!url) {
    throw new Error("VITE_DATABASE_URL environment variable is not set");
  }
  return url;
};

// Create Neon SQL client
const sql = neon(getDatabaseUrl());

// Create Drizzle database instance with schema
export const db = drizzle(sql, { schema });

// Export for direct SQL queries if needed
export { sql };
